import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Button, CardActions, CardText } from 'react-md';
import RegistrationCard from '../RegistrationCard';

class RangeRules extends Component {
  constructor(props) {
    super(props);

    this.state = {
      readingTime: 10,
    };

    this.checkReadingRuleTime = this.checkReadingRuleTime.bind(this);
  }

  componentDidMount() {
    // @see: https://github.com/airbnb/javascript/issues/684#issuecomment-172383685
    this.timer = setInterval(this.checkReadingRuleTime, 1000);
  }

  componentWillUnmount() {
    if (this.timer) {
      clearInterval(this.timer);
    }
  }

  checkReadingRuleTime() {
    if (this.state.readingTime > 0) {
      this.setState(prevState => ({
        readingTime: prevState.readingTime - 1,
      }));
    } else {
      if (this.timer) {
        clearInterval(this.timer);
      }
    }
  }

  render() {
    const { onSubmit } = this.props;
    return (
      <RegistrationCard title="Range Rules">
        <CardText>
          <ul>
            <li>
              Treat every gun as if it were
              loaded.
            </li>
            <li>
              Always keep the firearm muzzle
              pointed in safe direction (down range).
            </li>
            <li>
              Eye and ear protection is required
              before entering the range entrance doors.
            </li>
            <li>
              Keep all firearms inside your
              assigned stall at all times.
            </li>
            <li>
              Understand the mechanical and
              handling characteristics of the firearm you are using.
            </li>
            <li>
              Keep your finger off of the trigger
              until you are ready to fire.
            </li>
            <li>
              Be aware of your target's foreground
              and background.
            </li>
            <li>
              No rapid fire (more than one shot
              per second).
            </li>
            <li>No failure drills allowed.</li>
            <li>
              No drawing from holsters or
              concealment.
            </li>
            <li>
              Ensure all shots impact the
              target & bullet trap, no shooting walls, ceilings, or floors.
            </li>
            <li>
              Minimum target distance is 20 feet
              down range.
            </li>
            <li>
              If you have a problem with your
              firearm, <strong>
                LEAVE IT IN YOUR ASSIGNED STALL POINTED DOWN
                RANGE{' '}
              </strong> and ask a range officer for assistance. <strong>
                DO
                NOT BRING A PROBLEM FIREARM OFF THE RANGE.
              </strong>
            </li>
            <li>
              All firearms must remain safely
              cased, or locked open / clear when going into or out of the ranges.
            </li>
            <li>
              No persons are permitted forward of
              the shooting stalls & firing line <strong>AT ANY TIME.</strong>
            </li>
            <li>
              You are responsible for any and all
              damage that you cause to the range facility, including but not
              limited to - target carriers, walls, floors, ceilings, baffles, or
              stalls.
            </li>
          </ul>
        </CardText>
        <CardActions>
          <Button
            raised
            label={`I Accept & Understand the Range Rules
              ${(this.state.readingTime > 0)
                ? `(${this.state.readingTime})`
                : ""}
            `}
            disabled={this.state.readingTime > 0}
            primary
            className="md-cell--right"
            onClick={() => onSubmit({ nextStep: 'agreement' })}
          />
        </CardActions>
      </RegistrationCard>
    )
  }
}

RangeRules.propTypes = {
  onSubmit: PropTypes.func.isRequired,
};
RangeRules.defaultProps = {};

export default RangeRules;



// WEBPACK FOOTER //
// ./src/registration/components/RangeRules/RangeRules.jsx